import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface LiveVideoData {
  ivs_playback_url: string;
  auction_name?: string;
  auction_id?: number;
}

@Injectable({
  providedIn: 'root'
})
export class LiveVideoService {
  private liveVideoData$ = new BehaviorSubject<LiveVideoData | null>(null);
  private isVisible$ = new BehaviorSubject<boolean>(false);
  private position$ = new BehaviorSubject<{x: number, y: number}>({x: 20, y: 20});

  constructor() {}

  setLiveVideo(data: LiveVideoData | null) {
    this.liveVideoData$.next(data);
    if (data) {
      this.isVisible$.next(true);
    }
  }

  getLiveVideoData() {
    return this.liveVideoData$.asObservable();
  }

  getVisibility() {
    return this.isVisible$.asObservable();
  }

  getPosition() {
    return this.position$.asObservable();
  }

  setPosition(position: {x: number, y: number}) {
    this.position$.next(position);
  }

  show() {
    this.isVisible$.next(true);
  }

  hide() {
    this.isVisible$.next(false);
  }

  close() {
    this.liveVideoData$.next(null);
    this.isVisible$.next(false);
  }
}
